/**
 * 用于多厅主的不同配置，除了Constant.ts，其他文件不要使用这个文件
 */

let PackageConfig = {
    updatePackageName:"com.kingkong.atiantianpushb0616",
    WebsiteSign:"prod/heng/B01_tiantian",
    PackageName: "天天棋牌",
    // 平台标示符
    PackageFlag: "newPK",
    // 微信appkey
    WeChatAppID: "wx0eee872c5a98d3de",
    // 默认的客服地址
    CustomerServiceAddress: "https://direct.lc.chat/11684388/",
    // 首页网址
    HomeUrl:"https://888day.app",

    // 分享链接
    ShareUrl: "https://888day.app",
    // 服务器地址
    ServerAddresses: [
        "https://api.sasatt.com",
        "https://am.sasatt.com",
        "https://gf.sasatt.com"
    ],
    closeYxd:true,
    // 游戏盾相关
    // 游戏盾相关需要修改
    GameShieldAccessKey:"MiTNLXiTUkkESjMug69AACgWsyK-i5WNgnD26R-dOYONFoeZ-KiFO-ErZMZeCSTEISq_4390J+OhDwi+c-voPVXLgKQYZsATUYhAaZt8XIGijE5899ag1gYigWcQY90QnDT-M6AyK_Ko8IYrzDF_xiuTxTsQA1KlW2mTz6uFc7RB9qREFNyiV1LYKalA82uxL2ZCFVwVBr_EZT_Z_LCtBJLepkVaX3nZz5Gz85O+uRgr2tLSQhnMqN2qxFd_YD43_qBbt6t3NTfB6OjSAYtxLWZjcorifVz6JrV-0CkMs0wFv8qA_ffRJ9_aVraE6T+IUzsf4Eg+O2tQCu0D9PMUM9WozrDV-+1tX2clt4UbnbKC3Ju+fhQ1P9cq",
    GameShieldGroupName:"tiantian.AY517B5fx1.ftnormal01aj.com",
    GameShieldDomain: "tiantian",
    GameShieldPort: "80",
    InstallSDK: 2,
}

export default PackageConfig
